import { brochureContents } from '@/mocks/brochureData';
import { useTranslation } from 'react-i18next';

const CONTENTS_COUNT = 5;

export default function BrochureContents() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('brochure.contents.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('brochure.contents.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('brochure.contents.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">
            {t('brochure.contents.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: CONTENTS_COUNT }, (_, idx) => (
            <div
              key={idx}
              className="card-glow group bg-background-100/60 border border-background-200/60 p-6"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/[0.06] mb-4 group-hover:bg-accent-500/[0.12] transition-colors duration-300">
                <i className={`${brochureContents[idx]?.icon ?? ''} text-accent-500 text-lg`}></i>
              </div>
              <h3 className="text-[16px] text-foreground-800 tracking-[0.04em] font-medium mb-1">
                {t(`brochure.contents.${idx}.title`)}
              </h3>
              <p className="text-[13px] text-accent-500/70 tracking-[0.08em] mb-3 font-label">
                {t(`brochure.contents.${idx}.titleEn`)}
              </p>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {t(`brochure.contents.${idx}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <div className="max-w-[700px] bg-background-100/60 border border-background-200/60 p-5">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-accent-500/[0.06]">
                <i className="ri-information-line text-accent-500 text-lg"></i>
              </div>
              <div>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {t('brochure.contents.notice', { defaultValue: brochureContents[0]?.description ?? '' })}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <p className="flex items-center gap-2 text-[14px] text-foreground-500 tracking-[0.04em]">
            <i className="ri-mail-line text-accent-500 text-lg"></i>
            {t('brochure.pdfDl.button')}
          </p>
        </div>
      </div>
    </section>
  );
}